var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<ul class="nfd-tab-panel nfd-tab-panel-whited visible-lg visible-md"data-bind="\n		foreach: tabs,\n		css: { \'nfd-tab-item-title-hidden\': !isActiveTabTitleVisible() } \n	"> <li class="nfd-tab-item nfd-tab-item-strong"data-bind="\n			visible: visible,\n			click: $parent._handleClickOnTab.bind(null, $index()),\n			css: {\'nfd-tab-item-active\': $parent.isTabActive($index())}"> <a class="nfd-tab-panel-title text-normal nfd-tab-panel-title-grayed"data-bind="\n					html: htmlContent,\n					attr: {\n						href: $parent.props.onGenerateHref(key),\n						\'data-test-value\': key\n					}"></a> </li> </ul>';
}
return __p;
};
